<template>
  <div>
    <v-form v-model="otherInfoForm" ref="form">
      <v-row class="w--100">
        <v-col cols="12" md="4">
          <v-text-field
            hint="https://example.com یا http://exampl.ir"
            label="وبسایت"
            v-model="form.website"
            type="text"
            outlined
            dense
            :disabled="
              merchantIsApproved && !merchantMonitorFields.Website
                ? true
                : false
            "
            :rules="[
              (v) => {
                if (
                  v &&
                  !(
                    v.substring(0, 8) == 'https://' ||
                    v.substring(0, 7) == 'http://'
                  )
                ) {
                  return ' آدرس وب سایت حتماُ با https:// یا http:// باید شروع شود';
                } else return true;
              },
            ]"
          />
        </v-col>
        <v-col cols="12">
          <h4 class="mb-2">درباره کسب و کار *</h4>
          <div
            v-if="merchantIsApproved && !merchantMonitorFields.About"
            v-html="form.about"
          ></div>
          <html-editor
            v-else
            v-model="form.about"
            :htmlValue="form.about"
            @htmlChange="(a) => (form.about = a)"
          ></html-editor>
        </v-col>
        <v-col cols="12">
          <v-container fluid>
            <v-textarea
              clearable
              clear-icon="mdi-close-circle"
              label="خلاصه سئو پسند"
              v-model="form.seoSummary"
            ></v-textarea>
          </v-container>
        </v-col>
        <v-col cols="12">
          <advance-uploader
            class="mx-2"
            :stencilSize="true"
            title="آپلود لوگو *"
            cropTypeProp="آپلود لوگو"
            :imagesProps="logo"
            @imagesChange="setBusinessLogo"
            :single-file="true"
            :disabledBtn="
              merchantIsApproved && !merchantMonitorFields.LogoFileId
                ? true
                : false
            "
          ></advance-uploader>

          <HelperComponent
            class="mx-2 mt-2"
            helperId="image-supplier-logo-help"
          />
        </v-col>

        <v-col cols="12">
          <advance-uploader
            class="mx-2"
            :stencilSize="true"
            title="آپلود عکس پس زمینه * "
            cropTypeProp="آپلود عکس پس زمینه"
            :imagesProps="backGroundImage"
            @imagesChange="setBusinessBackGround"
            :single-file="true"
            :disabledBtn="
              merchantIsApproved && !merchantMonitorFields.BackgroundImage
                ? true
                : false
            "
          ></advance-uploader>
          <HelperComponent
            class="mx-2 mt-2 d-flex"
            helperId="image-cropper-supplier-backgroud"
          />
        </v-col>
        <v-col cols="12">
          <span
            >برای افزودن تعداد بیتشری عکس منتخب محصولات و خدمات، روی همین دگمه
            کلیک کنید.</span
          >
          <advance-uploader
            :stencilProps="{ aspectRatio: 16 / 9 }"
            :stencilSize="false"
            title="عکس های منتخب*"
            cropTypeProp="عکس های منتخب"
            :imagesProps="images"
            @imagesChange="setBusinessImages"
            :single-file="false"
            class="mx-2"
            :disabledBtn="
              merchantIsApproved && !merchantMonitorFields.ImagesFileIds
                ? true
                : false
            "
          ></advance-uploader>
          <HelperComponent
            class="mx-2 mt-2"
            helperId="image-cropper-service-product"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import HtmlEditor from '@/components/core/CKEditor';
import AdvanceUploader from '@/components/core/AdvanceUploader';
export default {
  props: {
    validateOtherInfo: {
      type: Boolean,
      default: false,
    },
    validationErr: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    businessRegistrationData: {
      type: Object,
      default: null,
    },
    merchantIsApproved: {
      type: Boolean,
      default: false,
    },
    merchantMonitorFields: {
      type: Object,
      default: null,
    },
  },
  components: {
    HtmlEditor,
    AdvanceUploader,
  },
  data() {
    return {
      form: {
        about: null,
        seoSummary:null,
        website: null,
        backgroundImage: null,
        logoFileId: null,
        imagesFileIds: [],
      },
      backGroundImage: [],
      images: [],
      logo: [],
      otherInfoForm: true,
    };
  },
  created() {
    if (this.isEdit && this.businessRegistrationData) {
      this.fillValue(this.businessRegistrationData);
    }
  },
  watch: {
    validateOtherInfo(aft, bef) {
      if (aft) {
        //Check about length to validate it
        if (this.form.about.length < 80) {
          //alert('متن درباره کسب  و کار کوتاه هست اندکی بیشتر توضیح دهید');
          this.$emit('validationFailed');
          this.$dialog.error({
            text: 'متن درباره کسب  و کار کوتاه هست حداقل ۳۰ کلمه ضروری است',
            title: 'خطا',
            persistent: true,
            actions: [
              {
                text: 'بستن',
                color: 'red',
              },
            ],
          });
          return;
        }
        if (this.form.logoFileId == null) {
          this.$emit('validationFailed');
          this.$dialog.error({
            text: 'انتخاب لوگو اجباری است!',
            title: 'خطا',
            persistent: true,
            actions: [
              {
                text: 'بستن',
                color: 'red',
              },
            ],
          });
          return;
        }
        if (this.form.imagesFileIds.length == 0) {
          this.$emit('validationFailed');
          this.$dialog.error({
            text: 'آپلود عکسهای منتخب اجباری است!',
            title: 'خطا',
            persistent: true,
            actions: [
              {
                text: 'بستن',
                color: 'red',
              },
            ],
          });
          return;
        }
        if (this.$refs.form.validate()) {
          this.$emit('nextStep', this.form, 'otherInfo');
        } else {
          this.$emit('validationFailed');
        }
      }
    },
  },
  methods: {
    fillValue(data) {
      this.form.website = data.website;
      this.form.about = data.about;
      this.form.seoSummary = data.seoSummary;
      if (data.backgroundImage) {
        this.backGroundImage = [
          {
            fileUrl: data.backgroundImage.thumbnailFileUrl,
            fileId: data.backgroundImage.fileId,
          },
        ];
        this.form.backgroundImage = data.backgroundImage.fileId;
      }
      if (data.logo) {
        this.logo = [
          {
            fileUrl: data.logo.fileUrl,
            fileId: data.logo.fileId,
          },
        ];
        this.form.logoFileId = data.logo.fileId;
      }
      if (data.images?.length) {
        this.images = JSON.parse(JSON.stringify(data.images));
        this.form.imagesFileIds = data.images.map((el) => {
          return el.fileId;
        });
      }
    },
    setBusinessImages(arr) {
      this.form.imagesFileIds = arr.map((el) => el.fileId);
    },
    setBusinessLogo(arr) {
      if (arr.length) {
        this.form.logoFileId = arr[0]['fileId'];
      }
    },
    setBusinessBackGround(arr) {
      if (arr.length) {
        this.form.backgroundImage = arr[0]['fileId'];
      }
    },
  },
};
</script>

<style></style>
